import {Component} from '@angular/core';

@Component({
    selector: 'nirby-download-modal',
    templateUrl: './download-modal.component.html',
    styleUrls: ['./download-modal.component.scss'],
})
export class DownloadModalComponent {
}
